import { QuestionBase } from './question.base';
import { find, isEqual, pullAllBy, difference } from 'lodash';
import { Reply, QuestionLevelAnswer } from '../../reply';
import {
  DependencyCondtionItem,
  Dependency,
  DependencyCondtionList
} from './dependency.types';

export class QuestionDependency implements Dependency {
  get id(): string {
    return this.question.get(['dependency', 'id']);
  }
  set id(v: string) {
    this.question.set(['dependency', 'id'], v);
  }
  get conditions(): DependencyCondtionList {
    return this.question.get(['dependency', 'conditions']) || [];
  }
  set conditions(v: DependencyCondtionList) {
    this.question.set(['dependency', 'conditions'], v);
  }
  get onContentUpdate() {
    return this.question.getChildTracker(['dependency']).onContentUpdate;
  }
  constructor(private question: QuestionBase) {
    this.question.getChildTracker('dependency');
  }
  hasCondition(condition: DependencyCondtionItem): boolean {
    return find(this.conditions, c => isEqual(condition, c)) ? true : false;
  }
  toggleCondition(condition: DependencyCondtionItem): void {
    let conditions = this.conditions;
    if (this.hasCondition(condition)) {
      conditions = pullAllBy(conditions, [condition], c =>
        isEqual(condition, c)
      );
    } else {
      conditions.push(condition);
    }
    this.question.set(['dependency', 'conditions'], conditions);
  }
  /**
   *
   * @param reply
   * checks if this question has a dependency and if it does, see if reply meets conditions about parent question
   */
  meetConditions(reply: Reply): boolean {
    let dependencyId = this.id;
    let conditions = this.conditions;
    if (!dependencyId || conditions.length === 0) {
      return true;
    } else {
      let parentQuestion = this.question.survey.getQuestions({
        id: this.id
      })[0];
      let answer: QuestionLevelAnswer = reply.get([parentQuestion.id]);
      if (answer) {
        return conditions.some(condition => {
          let answered_option_ids = Object.keys(answer);
          let condition_option_ids = Object.keys(condition);

          // if answered options contains all of condition options, return true
          return difference(condition_option_ids, answered_option_ids)
            .length === 0
            ? true
            : false;
        });
      } else {
        return false;
      }
    }
  }
}
